import { render } from "./MModal.vue?vue&type=template&id=c8b996e2&scoped=true"
import script from "./MModal.vue?vue&type=script&lang=js"
export * from "./MModal.vue?vue&type=script&lang=js"

import "./MModal.vue?vue&type=style&index=0&id=c8b996e2&lang=scss&scoped=true"
import "./MModal.vue?vue&type=style&index=1&id=c8b996e2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b996e2"]])

export default __exports__